var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSim = function SvgSim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.057,
    d: "M40.64 56H1.421L1 55.64V1.36L1.422 1h37.75l1.89 1.609V55.64l-.423.359Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.057,
    d: "m4.426 51.605-.293-.291V12.971l.293-.293h23.952l6.419 6.42v32.215l-.292.291z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.057,
    d: "m6.351 48.412-.293-.293V16.43l.293-.293h19.01l4.401 4.632V48.12l-.293.293z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.057,
    d: "M26.085 20.443H8.834a.77.77 0 0 0-.77.769v24.97a.77.77 0 0 0 .77.768h17.252a.77.77 0 0 0 .77-.769v-24.97a.77.77 0 0 0-.77-.768Zm-11.781 0V46.95m6.376-26.507V46.95m-8.86-13.254h2.484m6.376 0h2.483"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.057,
    d: "m26.854 37.614-3.918-3.917 3.918-3.917m-18.79 0 3.917 3.916-3.917 3.918m6.24-6.535h6.376m-6.376 5.234h6.376"
  })));
};
export default SvgSim;